import React, {
  forwardRef,
  useEffect, useCallback,
  useContext
} from "react";
import Highcharts from "highcharts/highstock";
import HighchartsVariwide from 'highcharts/modules/variwide'
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsSolidGauge from 'highcharts/modules/solid-gauge'
import HighchartsReact from "highcharts-react-official";
import { ChartType } from '../interface-type'
import { DarkTheme } from "./use-func/chart-theme";
import { useCallbackLastObjectA } from "./use-andaman";
import { MainContext } from "../context/main-context";
import { getValFromPath, jsonParse } from './use-func/util'
import moment from 'moment'

const Chart = forwardRef((props: ChartType, ref: any) => {
  const { hostA, tokenA } = useContext(MainContext)
  const getLasted = useCallbackLastObjectA
  HighchartsMore(Highcharts)
  HighchartsVariwide(Highcharts)
  HighchartsSolidGauge(Highcharts)
  Highcharts.setOptions(DarkTheme);

  const updateDataWithEvent = useCallback(
    async (message: any) => {
      const chart = ref.current.chart
      const payloadJson = jsonParse(message.payloadString)
      if (
        payloadJson &&
        payloadJson.storage &&
        props.fields.find((field: any) => field.storage === payloadJson.storage)
      ) {
        const lastData = await getLasted(props.host ? props.host : hostA, props.token ? props.token : tokenA, payloadJson.storage.split('.')[0], payloadJson.storage, 1)
        props.fields.map((field: any) => {
          if (field.storage === payloadJson.storage) {
            if (field.x.data_type === 'timestamp') {
              const x = Number(moment.unix(getValFromPath(lastData[0], `${field.x.path}.${field.x.name}`)).format("x"))
              const y = getValFromPath(lastData[0], `${field.y.path}.${field.y.name}`)
              chart.series.map((hcEvent: any) => {
                if (hcEvent.userOptions.id.includes(payloadJson.storage)) {
                  if (hcEvent.type === 'solidgauge') {
                    hcEvent.setData([y])
                  } else {
                    const lastposition = hcEvent.data.length - 1
                    if (hcEvent.data[lastposition].x !== x) {
                      hcEvent.data[0].remove(false);
                      hcEvent.addPoint([x, y]);
                    }
                  }
                }
              })

            }
          }
          return false
        })
      }

    },
    [ref, props.fields, getValFromPath],
  )

  useEffect(() => {
    if (props.event) {
      updateDataWithEvent(props.event.message)
    }
    return () => {
    };
  }, [updateDataWithEvent])

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <HighchartsReact
        ref={ref}
        highcharts={Highcharts}
        options={props.options}
      />
    </div>
  );
});

Chart.defaultProps = {
  event: null,
  host: null,
  token: null
}

export default Chart;
